import { GlSkeletonLoader } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'ReleaseSkeletonLoader',
    components: {
        GlSkeletonLoader
    }
};
